import React from "react";

// A refined mandala SVG that we reuse as a divider, hero backdrop, and page ornament.
// Keep strokes thin and colors from theme palette.
const Mandala = ({ className = "", size = 200, color = "#D4AF37", opacity = 0.35 }) => {
  const s = size;
  const c = s / 2;
  return (
    <svg
      width={s}
      height={s}
      viewBox={`0 0 ${s} ${s}`}
      className={className}
      style={{ opacity }}
      aria-hidden="true"
    >
      <defs>
        <radialGradient id={`mgrad-${s}`} cx="50%" cy="50%" r="50%">
          <stop offset="0%" stopColor={color} stopOpacity="0.15" />
          <stop offset="100%" stopColor={color} stopOpacity="0" />
        </radialGradient>
      </defs>
      <circle cx={c} cy={c} r={c - 2} fill={`url(#mgrad-${s})`} />
      <circle cx={c} cy={c} r={c - 6} fill="none" stroke={color} strokeWidth="0.6" />
      <circle cx={c} cy={c} r={c * 0.78} fill="none" stroke={color} strokeWidth="0.5" strokeDasharray="1 3" />
      <circle cx={c} cy={c} r={c * 0.55} fill="none" stroke={color} strokeWidth="0.6" />
      <circle cx={c} cy={c} r={c * 0.32} fill="none" stroke={color} strokeWidth="0.5" strokeDasharray="2 2" />
      {Array.from({ length: 16 }).map((_, i) => {
        const angle = (i * 360) / 16;
        return (
          <g key={i} transform={`rotate(${angle} ${c} ${c})`}>
            <path
              d={`M ${c} ${c * 0.18} Q ${c + 8} ${c * 0.4} ${c} ${c * 0.55} Q ${c - 8} ${c * 0.4} ${c} ${c * 0.18} Z`}
              fill={color}
              opacity="0.35"
            />
            <circle cx={c} cy={c * 0.14} r="1.4" fill={color} />
          </g>
        );
      })}
      {Array.from({ length: 8 }).map((_, i) => {
        const angle = (i * 360) / 8 + 22.5;
        return (
          <g key={`p-${i}`} transform={`rotate(${angle} ${c} ${c})`}>
            <path
              d={`M ${c} ${c * 0.6} Q ${c + 4} ${c * 0.72} ${c} ${c * 0.82} Q ${c - 4} ${c * 0.72} ${c} ${c * 0.6} Z`}
              fill={color}
              opacity="0.5"
            />
          </g>
        );
      })}
    </svg>
  );
};

export default Mandala;
